import { GlycerinSortMethod } from '@packages/tracking';

/**
 * Maps a given sorting key to its corresponding GlycerinSortMethod enum value.
 *
 * @param sortingKey A EPS-provided sorting key. Known values include 'relevance', 'price-asc', 'price-desc', 'novelty', 'brand-asc', 'brand-desc', and 'ratings'.
 * @param pageType The type of page on which sorting is applied. It could be 'serp' or 'productlist', which may use different sorting methods for the same key.
 * @returns The corresponding GlycerinSortMethod enum value for the given sorting criteria and page type.
 *
 * @example
 * getGlycerinSortMethod('price-asc', 'productlist')  // returns GlycerinSortMethod.PRICEASCENDING
 * getGlycerinSortMethod('relevance', 'serp')  // returns GlycerinSortMethod.SEARCHLOGIC
 *
 * @see GlycerinSortMethod For more information about each sorting method.
 */
export const getGlycerinSortMethod = (
  sortingKey: string,
  __typename: 'CategoryResult' | 'SuccessfulSearchResult',
): GlycerinSortMethod => {
  switch (sortingKey) {
    case 'relevance': {
      switch (__typename) {
        case 'SuccessfulSearchResult':
          return GlycerinSortMethod.SEARCHLOGIC;
        case 'CategoryResult':
          return GlycerinSortMethod.PRANK;
        default:
          return GlycerinSortMethod.POPULARITY;
      }
    }
    case 'price-asc':
      return GlycerinSortMethod.PRICEASCENDING;
    case 'price-desc':
      return GlycerinSortMethod.PRICEDESCENDING;
    case 'ratings':
      return GlycerinSortMethod.RATING;
    case 'novelty':
      return GlycerinSortMethod.NEW;
    default:
      return GlycerinSortMethod.OTHER;
  }
};
